import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface ConfirmDialogData {
  rows: number;
  enableTextField?: boolean;
  mandatoryTextField?: boolean;
  title?: string;
  message: string;
  additionalMessage: string;
  confirmText?: string;
  cancelText?: string;
  showCancel?: boolean;
  confirmButtonClass?: string;
  textFieldLabel: string;
  textFieldPlaceholder: string;
  textFieldValue?: string;
  minlengthTextField?: number;
  textFieldMaxLength: number;
}

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
  standalone: false,
})
export class ConfirmDialogComponent {
  textFieldValue: string = "";

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    // Initialize the textFieldValue if not already set
    if (!this.data.textFieldValue) {
      this.data.textFieldValue = "";
    }
  }

  onConfirm(): void {
    // Check if the field is required and empty
    if (
      this.data.enableTextField &&
      this.data.mandatoryTextField &&
      this.data.minlengthTextField &&
      (!this.data.textFieldValue ||
        this.data.textFieldValue.trim() === "" ||
        this.data.textFieldValue.length < this.data.minlengthTextField)
    ) {
      return; // Don't close the dialog if required field is empty
    }
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
